import React, { Component } from "react"
import { connect } from 'react-redux'
import {msg} from '../Notifications/MsgBox';
import validateUtil from '../../helpers/validateUtil'

class MainNotBotTabMenu extends Component {

    constructor(props) {
        super(props)
        this.isLockTab = this.isLockTab.bind(this)
    }

    isLockTab() {
        let check=false

        !this.props.isLockTabPO ?check=true:check=false;

        return check
    }

    CheckTable(tabid){
        if(tabid=='mr'){
            window.handleMRAmount()
            window.handleMREval()
        }
        if(!this.isLockTab() && tabid == 'gr'){
            //window.onChangeTabIR();
            return;
        }
        if(this.isLockTab())
        {
            if(!this.props.isLockTabPO && tabid !== 'po')
            {
                msg.error("กรุณากรอกข้อมูล Purchase / Contract Number");
                return "";
            }
            // else if(this.props.isLockTabIR && tabid !== 'ir')
            // {
            //     let listError=[]
            //     validateUtil.addListError(listError
            //         ,"T_IR_DETAIL"
            //         ,{"error_message": "กรุณาบันทึกข้อมูล Invoice Receipt"}
            //     )
            //     msg.warningSave(listError);
            //     return "";
            // }
        }
        return window.onChangeTab(tabid)
        //return
    }

    render() {

        return (
            <div className="row sp-project-counter-wrap">
                <div className="col-md-6 sp-project-counter-panel">
                    {/* <a href="#" className="sp-project-counter-link" id="rrsPoDetail" data-toggle="collapse" onClick={()=>this.CheckTable("po")}  data-target={this.isLockTab()?"":"#rrsTab1"} aria-expanded="true" aria-controls="rrsTab1"> */}
                    <a href="#" className="sp-project-counter-link collapsed" id="rrsPoDetail" onClick={()=>this.CheckTable("po")} data-toggle="collapse" data-target={this.isLockTab()?"":"#rrsTab1"} aria-expanded="false" aria-controls="rrsTab1">
                        <div className="sp-project-counter-label-box">
                            <div className="sp-project-counter-label">
                                <div className="sp-project-counter-label2">
                                    <span className="sp-project-counter-label-l">PO Detail  </span>
                                </div>
                                <span className="sp-project-counter-label-small">ระบุเงื่อนไขข้อมูลสำหรับบันทึกการประชุม</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div className="col-md-6 sp-project-counter-panel">
                    {/* <a href="#" className="sp-project-counter-link collapsed" id="rrsMomDetail" onClick={()=>this.CheckTable("mo")} data-toggle="collapse" data-target={this.isLockTab()?"":"#rrsTab2"} aria-expanded="false" aria-controls="rrsTab2"> */}
                    <a href="#" className="sp-project-counter-link" id="rrsMomDetail" data-toggle="collapse" onClick={()=>this.CheckTable("mo")}  data-target={this.isLockTab()?"":"#rrsTab2"} aria-expanded="true" aria-controls="rrsTab2">
                        <div className="sp-project-counter-label-box">
                            <div className="sp-project-counter-label">
                                <div className="sp-project-counter-label2">
                                    <span className="sp-project-counter-label-l">ผลการตรวจรับ</span>
                                </div>
                                <span className="sp-project-counter-label-small">กรุณาระบุข้อมูลผลการตรวจรับ</span>
                                <span className="sp-project-counter-label-small">ที่มีมติตรวจรับเรียบร้อยแล้วเท่านั้น</span>
                            </div>
                        </div>
                    </a>
                </div>
                
            </div>
        )
    }
}


const mapStateToProps = state => {
    const { AppRedux } = state
    return {
        isLockTabIR: AppRedux.isLockTabIR,
        isLockTabPO: AppRedux.isLockTabPO
    }
}

export default connect(
    mapStateToProps,
    null
)(MainNotBotTabMenu)